export default "__VITE_ASSET__C42ep5pV__"